import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Checkbox, FormControlLabel, Grid, IconButton, List, Paper, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import NoData from '../../../shared/ui/NoData/NoData';
import GeoZoneListItem from './GeoZoneListItem/GeoZoneListItem';
import style from '../CompanyGeoZonesPanel.module.css';

function GeoZonesSidebar({
  search,
  setSearch,
  setAddedZones,
  geoZones,
  setGeoZones,
  setSelectedGeoZones,
  page,
  setPage,
  getGetGeoZonesFunc,
  total,
  allGeoZones,
  maxItems,
  selectedGeoZones,
  onSelectGeoZone,
  PAGE_SIZE,
  isExactSearch,
  setIsExactSearch,
}) {
  return (
    <Grid item xs={3}>
      <Paper variant="outlined">
        <Box sx={{ padding: '16px 16px 0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <TextField
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              id="searchThree"
              label="Поиск"
              variant="outlined"
              sx={{ width: '100%' }}
              InputProps={{
                endAdornment: search.length >= 3 && (
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => {
                      setSearch('');
                      setAddedZones([]);
                      setGeoZones([]);
                      if (page === 0) {
                        getGetGeoZonesFunc('');
                      } else {
                        setPage(0);
                      }
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                ),
              }}
            />
            {!!selectedGeoZones.length && (
              <IconButton sx={{ p: 0 }} title="Сбросить выбранные геозоны" onClick={() => setSelectedGeoZones([])}>
                <CloseIcon />
              </IconButton>
            )}
          </Box>
          <FormControlLabel
            control={<Checkbox checked={isExactSearch} onChange={(e) => setIsExactSearch(e.target.checked)} />}
            label="Точное название"
          />
          {!!total && (
            <Typography my={1}>
              {search?.length >= 3 ? 'Найдено: ' : 'Всего: '}
              {total}
              {selectedGeoZones.length > 1 && (
                <> | Выбрано: {selectedGeoZones.length}</>
              )}
            </Typography>
          )}
        </Box>
        {allGeoZones.length ? (
          <List className={total ? style.geoZonesFoundList : style.geoZonesList}>
            {allGeoZones.map(
              (geoZone, index) =>
                index + 1 <= maxItems && (
                  <GeoZoneListItem
                    key={geoZone.id}
                    name={geoZone.name}
                    selected={selectedGeoZones.some((zone) => zone.geozoneId === geoZone.geozoneId)}
                    onClick={() => onSelectGeoZone(geoZone)}
                  />
                ),
            )}
          </List>
        ) : (
          <NoData text="Нет геозон" />
        )}
        {geoZones.length >= maxItems && (
          <Box sx={{ justifyContent: 'center', display: 'flex', marginBottom: '16px' }}>
            <Button
              variant="contained"
              onClick={() => setPage((prevState) => (page < maxItems / PAGE_SIZE ? prevState + 1 : prevState))}
            >
              Показать еще
            </Button>
          </Box>
        )}
      </Paper>
    </Grid>
  );
}

GeoZonesSidebar.propTypes = {
  search: PropTypes.string.isRequired,
  setSearch: PropTypes.func.isRequired,
  setAddedZones: PropTypes.func.isRequired,
  geoZones: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setGeoZones: PropTypes.func.isRequired,
  setSelectedGeoZones: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  getGetGeoZonesFunc: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  allGeoZones: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  maxItems: PropTypes.number.isRequired,
  selectedGeoZones: PropTypes.arrayOf(PropTypes.shape()),
  onSelectGeoZone: PropTypes.func.isRequired,
  PAGE_SIZE: PropTypes.number.isRequired,
  isExactSearch: PropTypes.bool.isRequired,
  setIsExactSearch: PropTypes.func.isRequired,
};

GeoZonesSidebar.defaultProps = {
  selectedGeoZones: [],
};

export default GeoZonesSidebar;
